import { mixpanelTrack } from "@helpers/mixpanel.helper";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import styled from "styled-components";

const Links = styled(Link)`
  font-size: 18px;
  font-weight: 500;
  font-family: var(--euclid-medium);
  color: #121252;
  text-decoration: none;
`;

const A = styled.a`
  font-size: 18px;
  font-weight: 500;
  font-family: var(--euclid-medium);
  color: #121252;
  text-decoration: none;
`;

const Menu = ({
	navInfo,
	navigationcontentcolor,
	activeStyle,
	navigationBackgroundColor,
	closeNavigationMenuModal,
	hasSubNav,
	isExpanded,
	...props
}) => {
	const pathname = usePathname();

	const handleClick = (e) => {
		e.stopPropagation();
		if (closeNavigationMenuModal) {
			setTimeout(() => {
				closeNavigationMenuModal();
			}, 700);
		}
	};

	return !navInfo.link.includes("help") ? (
		<Links
			href={navInfo.link}
			navigationcontentcolor={navigationcontentcolor}
			onClick={(e) => {
				mixpanelTrack("header_hypelink_clicked", {
					cta_location: pathname,
					cta_name: navInfo.name,
				});
				handleClick(e);
			}}
			{...props}
		>
			{navInfo.name}
		</Links>
	) : (
		<A
			href={navInfo.link}
			navigationcontentcolor={navigationcontentcolor}
			onClick={(e) => {
				mixpanelTrack("header_hypelink_clicked", {
					cta_location: pathname,
					cta_name: navInfo.name,
				});
				handleClick(e);
			}}
		>
			{navInfo.name}
		</A>
	);
};

export default Menu;
